// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Qw-z","smallCardRow":"Rw-z","largeCardRow":"Sw-z","productSearchRow":"Tw-z","curatedRow":"Uw-z"};